module.exports = __webpack_public_path__ + "static/media/completion.2ad55db4.svg";